export const CURRENCY_TYPES_DATA = [
  { label: 'U.S.Dollar (USD)', value: 'USD' },
  { label: 'European Euro (EUR)', value: 'EUR' },
  { label: 'Swiss Franc (CHF)', value: 'CHF' },
  { label: 'Japanese Yen (JPY)', value: 'JPY' },
]
